import indentationStyles from './indentation.scss';
var INDENT_STEP = parseInt(indentationStyles['indent-step']);
var INDENT_STEP_MOBILE = parseInt(indentationStyles['indent-step-mobile']);
var maxIndent = 10;
var sheet;
function getStyleSheet() {
    if (sheet) {
        return sheet;
    }
    var style = document.createElement('style');
    document.head.appendChild(style);
    sheet = style.sheet;
    return sheet;
}
function generateClasses(indent, isMobile) {
    if (indent <= maxIndent || typeof document === 'undefined') {
        return;
    }
    var css = getStyleSheet();
    var indentStep = isMobile ? INDENT_STEP_MOBILE : INDENT_STEP;
    for (var i = maxIndent + 1; i <= indent; i++) {
        var margin = indentStep * i;
        css.insertRule("._comment-thread-indent-".concat(i, " { margin-left: ").concat(margin, "px }"));
    }
    maxIndent = indent;
}
export function getIndentClassName(indent, isMobile) {
    if (indent <= 10) {
        return indentationStyles["indent-".concat(indent)];
    }
    generateClasses(indent, !!isMobile);
    return "_comment-thread-indent-".concat(indent);
}
//# sourceMappingURL=styles.js.map